import { apolloClient } from '~/apollo-client';
import { ContractVersion } from '~/services/fetch-vnm-terms';
import {
  Flex_CreateContractAgreementsMutation,
  Flex_CreateContractAgreementsMutationVariables,
} from '~/typings/graphql';
import { CREATE_CONTRACT_AGREEMENT } from './agree-to-terms.queries';

export const agreeToTerms = async (params: AgreeToTermsParams): Promise<AgreeToTermsResponse> => {
  const { userId, utilityAccountId, vnmSolarProjectContracts } = params;
  if (!vnmSolarProjectContracts?.length) return;

  const input = vnmSolarProjectContracts.map(contract => ({
    contractVersionId: contract.id,
    contractVersionLanguageId: contract.contractVersionLanguageId,
    userAgent: navigator.userAgent,
    userId,
    utilityAccountId,
  }));

  await apolloClient.mutate<
    Flex_CreateContractAgreementsMutation,
    Flex_CreateContractAgreementsMutationVariables
  >({
    mutation: CREATE_CONTRACT_AGREEMENT,
    variables: { input },
  });
};

export interface AgreeToTermsParams {
  userId: number;
  utilityAccountId?: number;
  vnmSolarProjectContracts?: ContractVersion[];
}

export type AgreeToTermsResponse = void;
